module.exports = __webpack_public_path__ + "img/Illustrations_Global-Settings@3x.bc11eca4.png";